<template>
  <div class="wrapper store-coop-list">
    <admin-title :title="$route.meta.name" />

    <div class="header-search">
      <el-form inline :model="searchData" label-width="">
        <el-form-item label="交易类型" class="trade-type-form-item">
          <el-radio-group v-model="searchData.tradeType" size="small">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button :label="TRADE_INCOME">收入</el-radio-button>
            <el-radio-button :label="TRADE_EXPENSE">支出</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="门店名称">
          <el-input
            v-model.trim="searchData.storeName"
            size="small"
            placeholder="请输入门店名称"
            clearable
            style="width: 180px"
          />
        </el-form-item>
        <el-form-item label="订单号">
          <el-input
            v-model.trim="searchData.orderNo"
            size="small"
            placeholder="请输入订单号"
            clearable
            style="width: 200px"
          />
        </el-form-item>
        <el-form-item label="动账类型">
          <el-select
            v-model="searchData.sourceType"
            size="small"
            placeholder="请选择"
            clearable
            style="width: 160px"
          >
            <el-option
              v-for="item in sourceTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="动账时间">
          <el-date-picker
            v-model="searchData.timeRange"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            size="small"
            class="account-flow-time-range"
          />
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" size="small" icon="el-icon-search" @click="handleQuery">
            查询
          </el-button>
          <el-button type="info" size="small" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-divider />
    <div class="toolbar-right">
      <el-button
        v-checkbtn="isShowBtn(AUTH_BTN.store_cooperation_account_flow_export)"
        type="primary"
        size="small"
        icon="el-icon-download"
        @click="exportExcel"
      >
        导出
      </el-button>
    </div>

    <tp-table
      :isNeedSerialNumber="true"
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
    />
  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import { getAccountFlowPageAPI, exportAccountFlowAPI } from "./api";

/** 交易类型：收入 */
const TRADE_INCOME = 1;
/** 交易类型：支出 */
const TRADE_EXPENSE = 2;

/** 动账类型筛选项，value 与接口 sourceType 一致 */
const sourceTypeOptions = [
  { label: "按期分账", value: "in:royaltyPeriod" },
  // { label: "提前买断分账", value: "in:royaltyBuyout" },
  { label: "订单取消分账", value: "in:royaltyCancel" },
  { label: "提现拒绝返还", value: "in:withdrawRejectRefund" },
  { label: "结算账户提现", value: "out:withdraw" },
];

/** 门店信息单元格：标签 + 值（h 供 JSX 编译使用） */
function coopJLine(h, label, val) {
  const text = val != null && val !== "" ? val : "-";
  return (
    <div class="j-line">
      <span class="lbl">{label}：</span>
      <span class="val">{text}</span>
    </div>
  );
}

const columns = [
  {
    label: "交易类型",
    prop: "tradeTypeName",
    minWidth: "90",
    customRender(h, row) {
      return <p class="joint-plain">{row.tradeTypeName || "-"}</p>;
    },
  },
  {
    label: "动账时间",
    prop: "createTime",
    minWidth: "170",
    customRender(h, row) {
      return <p class="joint-plain">{row.createTime || "-"}</p>;
    },
  },
  {
    label: "动账类型",
    prop: "sourceTypeName",
    minWidth: "140",
    customRender(h, row) {
      return <p class="joint-plain">{row.sourceTypeName || "-"}</p>;
    },
  },
  {
    label: "门店信息",
    prop: "storeInfo",
    minWidth: "300",
    customRender(h, row) {
      return (
        <div class="joint-cell">
          {coopJLine(h, "门店名称", row.storeName)}
          {coopJLine(h, "门店地址", row.storeAddress)}
          {coopJLine(h, "区域负责人", row.areaFollowUserName)}
        </div>
      );
    },
  },
  {
    label: "动账账户",
    prop: "accountTypeName",
    minWidth: "110",
    customRender(h, row) {
      return <p class="joint-plain">{row.accountTypeName || "-"}</p>;
    },
  },
  {
    label: "订单号",
    prop: "orderNo",
    minWidth: "220",
    customRender(h, row) {
      return (
        <div class="joint-cell">
          <p class="joint-plain">
            <span style="margin-right: 8px;">{row.orderNo || "-"}</span>
            {row.storeJointModeName ? (
              <el-tag size="mini" type="success">
                {row.storeJointModeName}
              </el-tag>
            ) : null}
          </p>
        </div>
      );
    },
  },
  {
    label: "期数",
    prop: "billNum",
    minWidth: "80",
    customRender(h, row) {
      const v = row.billNum;
      return <p class="joint-plain">{v != null && v !== "" ? v : "-"}</p>;
    },
  },
  {
    label: "交易金额",
    prop: "tradeAmount",
    minWidth: "120",
    customRender(h, row) {
      const v = row.tradeAmount;
      return <p class="joint-plain">{v != null && v !== "" ? v : "-"}</p>;
    },
  },
  {
    label: "交易后余额",
    prop: "afterAmount",
    minWidth: "120",
    customRender(h, row) {
      const v = row.afterAmount;
      return <p class="joint-plain">{v != null && v !== "" ? v : "-"}</p>;
    },
  },
];

export default {
  name: "JointAccountFlowList",
  mixins: [authBtnMixin],
  data() {
    return {
      columns,
      sourceTypeOptions,
      TRADE_INCOME,
      TRADE_EXPENSE,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        tradeType: "",
        storeName: "",
        orderNo: "",
        sourceType: "",
        timeRange: null,
      },
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    /** 组装列表查询参数 */
    buildQueryParams() {
      const params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        storeName: this.searchData.storeName || undefined,
        orderNo: this.searchData.orderNo || undefined,
      };
      if (this.searchData.tradeType !== "" && this.searchData.tradeType != null) {
        params.tradeType = this.searchData.tradeType;
      }
      if (this.searchData.sourceType) {
        params.sourceType = this.searchData.sourceType;
      }
      const range = this.searchData.timeRange;
      if (range && range.length === 2) {
        params.leftCreateDate = range[0];
        params.rightCreateDate = range[1];
      }
      return params;
    },
    /** 点击查询，从第一页开始拉取 */
    handleQuery() {
      this.currentPage = 1;
      this.getList();
    },
    /** 重置筛选项并刷新列表 */
    reset() {
      this.searchData = {
        tradeType: "",
        storeName: "",
        orderNo: "",
        sourceType: "",
        timeRange: null,
      };
      this.currentPage = 1;
      this.getList();
    },
    /** 组装导出参数，未填项传空字符串 */
    buildExportParams() {
      const range = this.searchData.timeRange;
      return {
        tradeType:
          this.searchData.tradeType !== "" && this.searchData.tradeType != null
            ? String(this.searchData.tradeType)
            : "",
        storeName: this.searchData.storeName || "",
        orderNo: this.searchData.orderNo || "",
        sourceType: this.searchData.sourceType || "",
        leftCreateDate: range && range.length === 2 ? range[0] : "",
        rightCreateDate: range && range.length === 2 ? range[1] : "",
      };
    },
    /** 拉取动账明细分页数据 */
    async getList() {
      const res = await getAccountFlowPageAPI(this.buildQueryParams());
      this.list = res.list || [];
      this.total = res.total || 0;
    },
    /** 导出当前筛选结果 */
    exportExcel() {
      exportAccountFlowAPI(this.buildExportParams());
    },
  },
};
</script>

<style lang="scss" scoped>
.trade-type-form-item.el-form-item {
  display: block !important;
  width: 100% !important;
  margin-right: 0 !important;
  margin-bottom: 12px !important;
}

.account-flow-time-range {
  width: 360px;
}

.toolbar-right {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}
</style>

<style lang="scss">
@import "../coop-list-table-cells.scss";
</style>
